import React from 'react';

export default function Header() {
  return (
    <div className="headerBox">
      <div className="headerTextBox">
        <div className="headerTitle">
          <h1>Track All of Your Fleet Data</h1>
        </div>
        {/* <div className="headerDescrip">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
        </div> */}
        {/* <button className="headerButton">Contact</button> */}
      </div>
    </div>
  );
}
